import { render } from "./Home.vue?vue&type=template&id=5255c8b6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=5255c8b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5255c8b6"

export default script